export default __webpack_public_path__ + "static/media/email.51aae281.svg";